<template>

    <m-edit1/>

    <m-single-page-1 v-bind='{...{"contentLink":"drivers"},...{}}' :style='""' class="col-12 mb-5" ></m-single-page-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSinglePage1 from '@moeinmdn/miw-alpha-components/src/package/Page/Single/SinglePage1';

export default {
    name: 'HomeView',
    components: {mEdit1, mSinglePage1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
